import camelGet from '@rover/react-lib/src/utils/camelGet';
import type { FetchInternalLinkingResponse } from '@rover/types/src/apiResponses/FetchInternalLinkingResponse';
import type { Locality } from '@rover/types/src/Locality';
import combinePaths from '@rover/utilities/combinePaths';
import { localityToPath } from '@rover/utilities/locality';

export const INTERNAL_LINKING_URL = 'frontend/internal-linking/';

export const get = async (locality: Locality): Promise<FetchInternalLinkingResponse> => {
  const url = combinePaths([INTERNAL_LINKING_URL, localityToPath(locality)]);
  return camelGet<FetchInternalLinkingResponse>({ url });
};
